function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-254.835 -88)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(254.835 88)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7253.333,699.033l-3.226-3.221,1.676-1.642c.1.1.183.206.275.3q3.713,3.727,7.429,7.454,1.852,1.858,3.7,3.715a3.435,3.435,0,0,1,.022,4.928q-2.925,2.963-5.869,5.906a3.265,3.265,0,0,1-3.751.6,3.752,3.752,0,0,1-1.031-.727c-2-1.99-4.008-3.972-6-5.971a3.463,3.463,0,0,1-.02-4.745c.674-.688,1.391-1.334,2.082-2.005q2.316-2.247,4.625-4.5C7253.271,699.1,7253.291,699.079,7253.333,699.033Zm-5.4,9.069H7262a1.1,1.1,0,0,0-.368-.755c-.475-.48-.954-.957-1.432-1.434q-2.375-2.375-4.747-4.749c-.159-.16-.31-.328-.468-.5-.06.053-.095.083-.128.115l-1.725,1.688-3.75,3.667c-.38.371-.761.741-1.135,1.119A.98.98,0,0,0,7247.928,708.1Z",
  transform: "translate(-7245.611 -694.171)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7813.754,1219.013c.32.509.625.974.912,1.451a14.114,14.114,0,0,1,1.244,2.45,2.135,2.135,0,0,1-.577,2.444,2.171,2.171,0,0,1-2.521.43,2.222,2.222,0,0,1-1.381-2.1,2.561,2.561,0,0,1,.261-1.043,17.693,17.693,0,0,1,1.4-2.612C7813.3,1219.7,7813.518,1219.379,7813.754,1219.013Z",
  transform: "translate(-7793.914 -1202.765)"
})));

var SvgFill = function SvgFill(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.158,
    height: 23.249,
    viewBox: "0 0 22.158 23.249",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fill.627c8290.svg";
export { ForwardRef as ReactComponent };